import debounce from "lodash.debounce"

const init = () => {

	const pubNavBar = document.querySelector('.pub-nav-bar');

	if (pubNavBar !== null)
	{
		window.addEventListener('resize', debounce((e) => {
			checkHeight(pubNavBar);
		}, 300))

		checkHeight(pubNavBar);
	}
}

const checkHeight = (pubNavBar) => {
	console.log('checking height');
	
	const navBarH   = pubNavBar.offsetHeight;
	const navLinks  = pubNavBar.querySelector('[data-nav-links]');
	const navLinksH = navLinks.offsetHeight;

	const showTriggerClass = 'pub-nav-bar--show-trigger';

	if (navLinksH > navBarH) {
		pubNavBar.classList.add(showTriggerClass);
	} else {
		pubNavBar.classList.remove(showTriggerClass);
	}

	pubNavBar.classList.add('pub-nav-bar--loaded');
}

export default init